module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-incoming-e0af1a6e89f700bc5d48b5c407947e27.svg";